import { Component } from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatTooltip } from '@angular/material/tooltip';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'app-clipboard-button',
    templateUrl: './clipboard-button.component.html',
    styleUrl: './clipboard-button.component.scss',
    imports: [
        MatIconButton,
        MatTooltip,
        MatIcon,
    ],
})
export class ClipboardButtonComponent {
    /**
     * Icon to show in the icon button
     */
    icon = 'copy';

    /**
     * Called when the user clicks the copy button
     * Sets the icon to 'check' and resets it to 'copy' after 2 seconds
     * Actual copy to clipboard functionality is handled by ngx-markdown and clipboard libraries
     */
    copy(): void {
        // Actual copy is already handled by ngx-markdown and the clipboard library so we don't have to do that here
        if (this.icon === 'copy') {
            this.icon = 'check';
            setTimeout(() => {
                this.icon = 'copy';
            }, 2000);
        }
    }
}
